export { default as ContentfulPicture } from "./ContentfulPicture";
